// src/pages/Dashboard.js
import { useNavigate } from "react-router-dom";
import SubscriptionStatus from "../components/SubscriptionStatus";
import WhatsAppHealth from "../components/WhatsAppHealth";
import { isAgent } from "../services/auth";

const Dashboard = () => {
  const navigate = useNavigate();
  const agentRole = isAgent();

  const quickActions = [
    {
      id: "broadcast",
      title: "Broadcast",
      description: "Send bulk promotional messages",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M12 22c1.1 0 2-.9 2-2H10c0 1.1.9 2 2 2z" />
          <path d="M18.364 5.636A9 9 0 0 1 21 12a9 9 0 0 1-2.636 6.364" />
          <path d="M5.636 5.636A9 9 0 0 0 3 12a9 9 0 0 0 2.636 6.364" />
          <path d="M15.536 8.464A5 5 0 0 1 17 12a5 5 0 0 1-1.464 3.536" />
          <path d="M8.464 8.464A5 5 0 0 0 7 12a5 5 0 0 0 1.464 3.536" />
          <circle cx="12" cy="12" r="1" fill="currentColor" />
        </svg>
      ),
      path: "/broadcast",
    },
    {
      id: "templates",
      title: "Template List",
      description: "Manage message templates",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      ),
      path: "/templateList",
    },
    {
      id: "chats",
      title: "Chats",
      description: "View WhatsApp conversations",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          <path d="M8 10h8M8 14h5" />
        </svg>
      ),
      path: "/chats",
    },
    {
      id: "customers",
      title: "Customer Details",
      description: "Manage customer information",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      path: "/customerDetails",
    },
    {
      id: "groups",
      title: "Customer Groups",
      description: "Organize customer groups",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      path: "/groupList",
    },
    {
      id: "history",
      title: "Message History",
      description: "View sent messages",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </svg>
      ),
      path: "/messageHistory",
    },
    {
      id: "analytics",
      title: "Analytics",
      description: "View messaging insights & statistics",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M3 3v18h18" />
          <path d="M18 17V9" />
          <path d="M13 17V5" />
          <path d="M8 17v-3" />
        </svg>
      ),
      path: "/analytics",
    },
    {
      id: "bulk-import",
      title: "Bulk Import",
      description: "Import customers from CSV/Excel",
      iconBg: "bg-blue-100",
      icon: (
        <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
        </svg>
      ),
      path: "/bulk-import",
    },
  ];

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-6">
        <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
          Welcome to Dashboard
        </h1>
        <p className="text-gray-600">
          Access all your promotional tools and analytics
        </p>
      </div>

      {/* Subscription Status — hidden for agents */}
      {!agentRole && (
        <div className="mb-6">
          <SubscriptionStatus />
        </div>
      )}

      {/* WhatsApp Account Health */}
      <div className="mb-6">
        <WhatsAppHealth />
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {quickActions.filter((a) => !(agentRole && a.id === "broadcast")).map((action) => (
          <button
            key={action.id}
            onClick={() => navigate(action.path)}
            className="bg-blue-50 border border-blue-100 rounded-xl p-5 text-left hover:bg-blue-100 hover:border-blue-200 hover:shadow-sm transition-all duration-200 group"
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 transition-opacity duration-200 group-hover:opacity-80 ${action.iconBg}`}>
              {action.icon}
            </div>
            <p className="text-sm font-semibold text-gray-800">{action.title}</p>
            <p className="text-xs text-gray-400 mt-0.5 leading-snug">{action.description}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
